import SimpleReactValidator from 'pu-utils/simple-react-validator';

export const validator = new SimpleReactValidator({});


// export const validatorCb = (prevValidationResult) => {
//   if (!validator.allValid()) {
//     validator.showMessages();
//     dispatch(updateValidatorFlagFabrication());
//     validateResult = false;
//   }
// }